import React from 'react'

function index() {
    return (
        <div>
            <h1>news</h1>
        </div>
    )
}

export default index
